import {routesNames} from "@/core/constants";
import desentranhamentoRoutes from '@/views/routers/routes/ata/processo-digital-aditivo-apostila/desentranhamento/desentranhamento';
import TipoModeloDocumento from "@/core/constants/tipo-modelo-documento";
import ModalDesentranhamentoAditivoApostilaView
	from "@/views/pages/ata/acessar/aditivo-apostila/desentranhamento/ModalDesentranhamentoAditivoApostilaView.vue";

export default [
	{
		name: routesNames.ADITIVO_APOSTILA.PROCESSO_DIGITAL.DESENTRANHAMENTO.DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW,
		path: '/ata/:id/aditivo-apostila/:idAditivoApostila/processo-digital/:idTermo/desentranhar/',
		component: ModalDesentranhamentoAditivoApostilaView,
		props: route => ({
			rotaVoltarParaListagem: routesNames.ATA.ATA_ACESSAR_ADITIVO_APOSTILA_VIEW,
			parametrosRotaVoltarParaListagem: { id: route.params.id, idAditivoApostila: route.params.idAditivoApostila, tipoAcesso: 'editar' },
			tipoDocumento: TipoModeloDocumento.ADITIVO_APOSTILA
		}),
		children: [...desentranhamentoRoutes],
	},
]
